import { Component, ViewChild } from "@angular/core";
import { AdaptHtmlEditorComponent } from "@common/ux/html-editor/html-editor.component";
import { WorkflowStepComponent } from "@org-common/lib/workflow/workflow-component-registry";
import { WorkflowStepComponentAdapter } from "@org-common/lib/workflow/workflow-step-component-adapter";
import { BehaviorSubject } from "rxjs";
import { ICreateValueData } from "../create-value-workflow";

@WorkflowStepComponent("adapt-create-value-meaning")
@Component({
    selector: "adapt-create-value-meaning",
    templateUrl: "./create-value-meaning.component.html",
    styleUrls: ["./create-value-meaning.component.scss"],
    standalone: false,
})
export class CreateValueMeaningComponent extends WorkflowStepComponentAdapter {
    public data?: ICreateValueData;

    public workflowStepCompleted = new BehaviorSubject<boolean>(false);
    public isEditorValid = true;
    @ViewChild(AdaptHtmlEditorComponent) public set adaptHtmlEditorComponent(value: AdaptHtmlEditorComponent | undefined) {
        value?.setElementMaxHeightToViewportBottom();
    }

    public constructor() {
        super();
    }

    public async workflowStepOnInit() {
        this.data = this.workflowStep?.workflow.runData;
        if (!this.data) {
            throw new Error("Workflow data is not available");
        }

        this.validateEntities();
    }

    public validateEntities() {
        this.workflowStepCompleted.next((this.data?.value?.entityAspect.validateEntity() ?? false) && this.isEditorValid);
    }
}
